import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectbookingdetails, bookingdetails, walletbooking, selectwalletbooking, selectDetailsLoading } from "./HotelSlice";
import { selectCurrentUser } from "../auth/authSlice";
import { toast } from 'react-hot-toast';
import { CheckCircle, XCircle } from 'lucide-react';
import CancellationPolicyPopup from "./CancellationPolicyPopup";
import { encryptAES } from '../../utils/crypto';
import { getapiKey, getdomainFullURL } from "../../api/axios";
import { openEasebuzzPaymentModal } from '../../services/easebuzzServiceNew';
import WalletUtils from '../../utils/walletUtils';
import { handleEasebuzzResponse, initiateEasebuzzPaymentThunk } from '../payment/paymentSlice';
import { useNavigate } from 'react-router-dom';
import BookingReviewShimmer from './BookingReviewShimmer';
import CurFt from '../../components/CurFt';
import { usePaymentProcessRecharge } from '../../services/usePaymentProcessRecharge';
const PaymentPage = () => {
    const [openConfirm, setOpenConfirm] = useState(false);
    const { paymentInitiated, paymentStatus, paymentData } = useSelector((state) => state.payment);
    const [showCancellationPopup, setShowCancellationPopup] = useState(true);
    const user = useSelector(selectCurrentUser)
    const DetailsLoading = useSelector(selectDetailsLoading)
    const selectbookingdetailsData = useSelector(selectbookingdetails)
    const selectwalletbookingresponse = useSelector(selectwalletbooking)
    const location = useLocation();
    const dispatch = useDispatch();
    const [BookingStatus, setBookingStatus] = useState([]);
    const [BookingId, setBookingId] = useState([]);
    const [paymentType, setpaymentType] = useState("wallet");
    const [formData, setFormData] = useState({});
    const [ErrorMessage, SetErrorMessage] = useState('');
    const [showUseWallet, setshowUseWallet] = useState([]);
    const [finalAmount, setFinalAmount] = useState([]);
    const [checkUseWallet, setcheckUseWallet] = useState(false);
    const HotelDetails = selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData?.HotelDetails
    // const searchQuery = selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData.searchQuery.searchQuery
    const RoomInfos = selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData?.RoomInfo
    const WalletBalance = selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData?.WalletBalance
    const fares = selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData?.fare
    const travellers = selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData?.travellers
    const CurrencySymbol = selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData?.HotelDetails?.currency || "INR"
    // Handles the failure response shape: { status: { success: false, httpStatus }, message: "..." }
    // e.g. credit limit exceeded (401). Existing success-path logic above is untouched.
    const apiErrorMessage = selectbookingdetailsData?.status?.success === false
        ? selectbookingdetailsData?.message
        : null

    const [errorMessageRecharge, SetErrorMessageRecharge] = useState('loading');
    const [paymentHookStatusRecharge, setpaymentHookStatusRecharge] = useState(null);
    const [ResponseData, SetResponseData] = useState(null);
    const { handleProceedRecharge } = usePaymentProcessRecharge({
        SetErrorMessageRecharge: SetErrorMessageRecharge,
        setpaymentHookStatusRecharge: setpaymentHookStatusRecharge,
        SetResponseData: SetResponseData,
    });

    const navigate = useNavigate()
    useEffect(() => {
        const parts = location.pathname.split("/").filter(Boolean);
        const bookingId = parts[parts.length - 1];
        setBookingId(bookingId)
        FetchBookingDetails({
            FormData: {
                BookingID: bookingId,
            }
        });

    }, [location.pathname]);
    useEffect(() => {
        if (selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData.HotelDetails?.BookingStatus == 1) {
            setTimeout(() => {
                navigate(-3);
            }, 100);
        }
    }, [selectbookingdetailsData])

    useEffect(() => {
        if (apiErrorMessage) {
            toast.error(apiErrorMessage)
            setTimeout(() => {
                navigate('/hotel');
            }, 100);
        }
    }, [apiErrorMessage])

    const FetchBookingDetails = async (payload) => {
        try { await dispatch(bookingdetails(payload)).unwrap(); }
        catch (err) { console.error("Fetch failed:", err); }
    };
    const calculatePaxCounts = (data) => {
        if (!data || !Array.isArray(data)) {
            return { adults: 0, children: 0, infants: 0 };
        }

        const counts = data.reduce((acc, roomGroup) => {
            if (roomGroup.Rooms && Array.isArray(roomGroup.Rooms)) {
                roomGroup.Rooms.forEach(room => {
                    acc.adults += room.Adult || 0;
                    acc.children += room.Child || 0;
                    acc.infants += room.Infant || 0;
                });
            }
            return acc;
        }, { adults: 0, children: 0, infants: 0 });

        return counts;
    };

    const paxCounts = calculatePaxCounts(
        selectbookingdetailsData?.data?.RoomInfo ||
        selectbookingdetailsData?.payload?.RoomInfo ||
        selectbookingdetailsData?.RoomInfo ||
        selectbookingdetailsData?.result?.RoomInfo
    );

    const ViewTicketDetails = () => {
        window.location.href = `/hotel/paymentConfirmation/${BookingId}`;
    }
    const [isWalletBookingSubmitted, setIsWalletBookingSubmitted] = useState(false);

    const handleuseWallet = (event) => {
        const { value, checked } = event.target;
        setcheckUseWallet(checked)
    }
    useEffect(() => {
        // Check if all required data is available
        if (!selectbookingdetailsData?.fare?.GrandTotal ||
            !travellers?.[0]?.[0]?.fname ||
            !user?.UserData?.user?.id) {
            return;
        }
        let Amount
        if (paymentType == "self card") {
            Amount = (selectbookingdetailsData?.fare?.GrandTotal)
            if (WalletBalance?.balances?.bookable_balance < fares.GrandTotal) {
                setshowUseWallet(true)
            }
        } else if (paymentType == "customer card") {
            setshowUseWallet(false)
            Amount = selectbookingdetailsData?.fare?.GrandTotal + selectbookingdetailsData?.fare?.TotalAgentMarkup
        } else {
            setshowUseWallet(false)
        }
        if (checkUseWallet && paymentType === 'self card') {
            Amount = (Amount - WalletBalance?.balances?.bookable_balance)
        }
        setFinalAmount(Amount)
        const bookingData = {
            "paymentMode": 1,
            "usereward": 0,
            "usewallet": checkUseWallet,
            "BookingID": BookingId
        };

        let encrypt = encryptAES(JSON.stringify(bookingData), getapiKey(), getapiKey())
        let txnid = "TXN" + Date.now()

        const hash = WalletUtils.walletCode(
            txnid,
            txnid,
            Amount && Amount.toFixed(2),
            travellers[0][0].fname,
            travellers[0][0].mobile,
            travellers[0][0].email,
            "Hotel Booking"
        );

        const customerInfo = {
            txnid: txnid,
            amount: Amount && Amount.toFixed(2),
            name: travellers[0][0].fname,
            email: travellers[0][0].email,
            phone: travellers[0][0].mobile,
            productinfo: "Hotel Booking",
            surl: getdomainFullURL() + "/payment/payment-success?planType=2&BookingID=" + BookingId,
            furl: getdomainFullURL() + "/payment/payment-success?planType=2&BookingID=" + BookingId,
            udf1: BookingId,
            udf2: "2",
            udf3: "Web-B2B",
            udf4: (user?.UserData.user.UserType === 7) ? user?.UserData.user.UserSysId : user.UserData.user.id,
            udf5: user.UserData.user.AgencyID,
            udf6: "INR",
            udf7: encrypt,
            udf8: "",
            udf9: "",
            udf10: "",
            securecode: hash,
        };


        setFormData(customerInfo)
    }, [selectbookingdetailsData, travellers, user, BookingId, paymentType, checkUseWallet, showUseWallet])

    useEffect(() => {
        // If payment is initiated and we have access key, open the modal
        if (paymentInitiated && paymentData && paymentData.accessKey) {
            openPaymentModal();
        }
    }, [paymentInitiated, paymentData]);
    const openPaymentModal = () => {
        try {
            openEasebuzzPaymentModal(
                paymentData.enviroment,
                paymentData.accessKey,
                formData,
                (response) => {
                    // Handle the payment response
                    dispatch(handleEasebuzzResponse(response));
                    // You might want to verify the payment with your backend here
                    if (response.status === 'success') {
                        const WalletopUp = {
                            "customer_id": user?.UserData?.user.id,
                            "currency": CurrencySymbol,
                            "amount": fares && fares.GrandTotal,
                            "PaymentMode": response.card_type + '-Web-B2B',
                            "ReferenceNo": BookingId,
                            "Notes": 'Wallet Recharge - ' + response.easepayid
                        }

                        setTimeout(() => {
                            // InitiatedBookingProcess()
                            ViewTicketDetails()
                        }, 3000);
                        // if (user?.UserData?.user?.AgencyID === 42) {
                        //   setTimeout(() => {
                        //     if (user?.UserData?.user?.AgencyID === 42) {
                        //       // InitiatedBookingProcess()
                        //       ViewTicketDetails()
                        //     }
                        //   }, 3000);
                        // }

                        // if (user?.UserData?.user?.AgencyID !== 42) {
                        //   dispatch(clearWalletError());
                        //   dispatch(DoWalletTopUp({ WalletopUp, currency })).unwrap();
                        // }
                        // dispatch(verifyEasebuzzPayment({
                        //   txn_id: response.txnid,
                        //   amount: formData.amount,
                        //   email: formData.email
                        // }));
                    } else {
                        toast.error(response.status, { autoClose: 2000 });
                        SetErrorMessage(response.status)
                        setBookingStatus('paymentfailed')
                        setTimeout(() => {
                            window.location.reload()
                        }, 3000);
                    }
                }
            );
        } catch (error) {
            SetErrorMessage('Failed to proceed payment')
            setBookingStatus('paymentfailed')
            console.error('Failed to open payment modal:', error);
        }
    };
    const handlePayment = async (e) => {
        if (paymentType == "wallet") {
            if (WalletBalance && WalletBalance?.balances?.bookable_balance < fares.GrandTotal) {
                toast.error('Insufficient Wallet Balance')
                return false
            } else {
                const bookingData = {
                    "paymentMode": 1,
                    "usereward": 0,
                    "usewallet": checkUseWallet,
                    "BookingID": BookingId
                };

                setIsWalletBookingSubmitted(true);
                await MakeWalletBooking(bookingData);
            }
        } else {
            handleProceedRecharge(formData);
            // dispatch(initiateEasebuzzPaymentThunk(formData));
        }
    }
    useEffect(() => {
        if (paymentHookStatusRecharge === "success") {
            toast.success("Payment proceed successful. Please wait...", { autoClose: 4000 });
            setIsWalletBookingSubmitted(false);
            setTimeout(() => {
                ViewTicketDetails()
            }, 2000);
        } else if (paymentHookStatusRecharge === "paymentfailed") {
            SetErrorMessage('Failed to proceed payment')
            setBookingStatus('paymentfailed')
            setIsWalletBookingSubmitted(false);
            setTimeout(() => {
                window.location.reload()
            }, 2000);
            toast.error("Payment proceed failed. plese contact with support team.", { autoClose: 4000 });
        }
    }, [paymentHookStatusRecharge, errorMessageRecharge]);

    useEffect(() => {
        if (isWalletBookingSubmitted && selectwalletbookingresponse?.status?.success) {
            setBookingStatus(selectwalletbookingresponse.message);
            setIsWalletBookingSubmitted(false);
            if (selectwalletbookingresponse.message == 'Success') {
                setTimeout(() => {
                    window.location.href = `/hotel/paymentConfirmation/${BookingId}`;
                }, 3000);
            }
        }
        else if (isWalletBookingSubmitted && selectwalletbookingresponse?.status?.success === false) {
            // Booking process API failure, e.g. { status: { success: false, httpStatus: 2001 }, message: "Please, enter valid PAN number." }
            setIsWalletBookingSubmitted(false);
            toast.error(selectwalletbookingresponse.message)
            setTimeout(() => {
                navigate(-1);
            }, 3000);
        }
    }, [selectwalletbookingresponse, isWalletBookingSubmitted]);

    const MakeWalletBooking = async (payload) => {
        try {
            await dispatch(walletbooking(payload)).unwrap();
        } catch (err) {
            console.error("Fetch failed:", err);
        }
    };
    const handleEditPax = (e) => {
        navigate(-1)
    }
    return (
        <>
            {DetailsLoading ? (
                <>
                    <div className="p-4">
                        <BookingReviewShimmer />
                    </div>
                </>
            ) : apiErrorMessage ? (
                <div className="max-w-2xl mx-auto p-6">
                    <div className="flex items-start gap-3 bg-red-50 border border-red-200 rounded-xl p-5">
                        <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" />
                        <div>
                            <h2 className="text-red-700 font-semibold mb-1">Unable to proceed</h2>
                            <p className="text-red-600 text-sm">{apiErrorMessage}</p>
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <div className="max-w-7xl mx-auto p-6 bg-white">
                        <h1 className="text-2xl font-bold text-gray-800 mb-6">Payment</h1>
                        {BookingStatus && BookingStatus.length > 0 && (
                            <span className="grid grid-cols-3 items-center w-full gap-4">
                                <div className="flex items-center gap-4 justify-self-start">
                                    <CheckCircle className="w-16 h-16 text-green-500" />
                                    <h2 className="text-xl font-bold text-green-600">
                                        Booking {BookingStatus}
                                    </h2>
                                </div>
                                <button
                                    // onClick={ViewTicketDetails}
                                    className="bg-green-600 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-green-700 transition justify-self-center"
                                >
                                    View Ticket
                                </button>
                                <div></div>
                            </span>
                        )}

                        <div className="flex gap-6">
                            <div className="flex-1 space-y-6">
                                <div className="border border-gray-200 rounded-lg p-6">
                                    <h2 className="text-xl font-semibold text-gray-800 mb-2">{HotelDetails && HotelDetails.name}</h2>
                                    <p className="text-gray-600 mb-1">  {HotelDetails && HotelDetails?.ad?.adr},  {HotelDetails && HotelDetails?.ad?.adr2} {HotelDetails && HotelDetails?.ad?.postalCode},{HotelDetails && HotelDetails?.ad?.ctn}, {HotelDetails && HotelDetails?.ad?.cn}</p>
                                    {/* <div className="bg-yellow-50 border border-yellow-200 rounded p-3 mb-4">
                                        <p className="text-yellow-700 text-sm">
                                            Please bear in mind that this property is 30.0 km from Delhi city center.
                                        </p>
                                    </div> */}
                                    <div className="grid grid-cols-2 gap-6 mb-6">
                                        <div>
                                            <h3 className="font-semibold text-gray-700 mb-2">CHECK IN</h3>
                                            <p className="text-gray-600">{HotelDetails && HotelDetails.checkinDate}</p>
                                            <p className="text-gray-600">12 PM</p>
                                        </div>
                                        <div>
                                            <h3 className="font-semibold text-gray-700 mb-2">CHECK OUT</h3>
                                            <p className="text-gray-600">{HotelDetails && HotelDetails.checkoutDate}</p>
                                            <p className="text-gray-600">11 AM</p>
                                        </div>
                                    </div>

                                    <div className="bg-gray-50 rounded p-4 mb-6">
                                        <p className="text-gray-700 font-medium">
                                            {fares && fares.nightCoun} Nights | {paxCounts.adults} Adults, {paxCounts.children} Children | {fares && fares.roomCoun} Rooms
                                        </p>
                                    </div>
                                    {RoomInfos && RoomInfos.length > 0 && RoomInfos[0].Rooms[0] && (() => {
                                        const roomGroup = RoomInfos[0];
                                        const room = roomGroup.Rooms[0];

                                        return (
                                            <div className={`flex gap-4 p-4 border rounded-lg cursor-pointer transition-all duration-200 border-gray-200 hover:border-gray-400`}>

                                                <div className="flex-1">
                                                    <div className="mb-2">
                                                        <h3 className="font-semibold text-lg">{room.RoomType}</h3>
                                                        <p className="text-gray-600 text-sm">
                                                            {room.MealBase} • {roomGroup.IsPan ? "PAN required" : "No PAN required"}
                                                        </p>
                                                    </div>

                                                    <div className="flex flex-wrap gap-4 mb-3">
                                                        {room.Extrabenefits && room.Extrabenefits.map((benefit, benefitIdx) => (
                                                            <div key={benefitIdx} className="flex items-center text-green-600 text-sm">
                                                                <i className="fas fa-check mr-1"></i>
                                                                <span>{benefit}</span>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    <div className="flex justify-between items-center pt-3 border-t border-gray-200">
                                                        <div className="text-sm text-gray-600">
                                                            <span>{room.rooms || 1} Room(s)</span>
                                                            <span className="mx-2">•</span>
                                                            <span>{room.nights || roomGroup.Nights || 1} Night(s)</span>
                                                        </div>

                                                        <div className="flex items-center gap-4">
                                                            <div className="text-right">
                                                                <p className="font-semibold text-lg">{CurrencySymbol} {room.HotelRoomPrice * room.rooms || room.pernightperroomprice * room.rooms}</p>

                                                                {showCancellationPopup && roomGroup && (
                                                                    <CancellationPolicyPopup
                                                                        cancellationData={roomGroup.CancelArr}
                                                                        currencySymbol={CurrencySymbol}
                                                                        onClose={() => setShowCancellationPopup(false)}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })()}
                                </div>
                                <div className="border border-gray-200 rounded-lg p-6">
                                    <h3 className="font-semibold text-gray-800 mb-4">Hotel Decription</h3>

                                    {HotelDetails && HotelDetails.des && HotelDetails.des.filter((item) => item.key !== "Default" && typeof item.value === "string").length > 0 ? (
                                        HotelDetails.des
                                            .filter((item) => item.key !== "Default" && typeof item.value === "string")
                                            .map((item, index) => (
                                                <div key={index} className="mb-4">
                                                    <h4 className="font-medium text-gray-700 mb-2">{item.key}</h4>
                                                    <p className="text-gray-600">{item.value}</p>
                                                </div>
                                            ))
                                    ) : (
                                        <p className="text-gray-500">No details available</p>
                                    )}


                                    <div className="border-t border-gray-200 pt-4 mb-6">
                                        <p className="text-gray-500 text-xs italic">
                                            <strong>Disclaimer notification:</strong> Amenities are subject to availability and may be chargeable as per the hotel policy.
                                        </p>
                                    </div>
                                </div>

                                <div className="border border-gray-200 rounded-lg p-6">


                                    <div className="border-t border-gray-200 pt-4">
                                        <div className="flex justify-between items-center mb-3">
                                            <h3 className="text-lg font-semibold text-gray-800">Primary Guest</h3>
                                            <button className="text-blue-600 text-sm font-medium hover:text-blue-800" onClick={handleEditPax}>
                                                Edit Pax
                                            </button>
                                        </div>

                                        <div className="bg-gray-50 rounded-lg p-4">
                                            <h4 className="font-semibold text-gray-800 mb-2">{travellers && travellers[0][0].title} {travellers && travellers[0][0].fname} {travellers && travellers[0][0].lname} </h4>
                                            <p className="text-gray-600 text-sm">Mobile - +{travellers && travellers[0][0].countrycode}{travellers && travellers[0][0].mobile}</p>
                                            <p className="text-gray-600 text-sm">Email - {travellers && travellers[0][0].email}</p>
                                        </div>
                                    </div>
                                    <div className="border-t border-gray-200 pt-4 mt-4">
                                        <h3 className="text-lg font-semibold text-gray-800 mb-3">Payment Mode</h3>

                                        <div className="bg-gray-50 rounded-lg p-4 mb-4">
                                            <h4 className="font-semibold text-gray-800 mb-3">Total Amount - (<CurFt currency={fares && fares?.symbol || "INR"} price={finalAmount || fares && fares.GrandTotal} />) </h4>

                                            <div className="space-y-3">
                                                <label className="flex items-center">
                                                    <input type="radio" name="payment" className="mr-2" checked={paymentType === "wallet"} onChange={(e) => e.target.checked && setpaymentType("wallet")} disabled={WalletBalance?.balances?.bookable_balance < fares.GrandTotal} />
                                                    <span className="text-gray-700">Wallet Bal:(<CurFt currency={fares && fares?.symbol || "INR"} price={WalletBalance && WalletBalance?.balances?.bookable_balance} />)</span>
                                                </label>
                                                <label className="flex items-center">
                                                    <input type="radio" name="payment" className="mr-2" checked={paymentType === "self card"} onChange={(e) => e.target.checked && setpaymentType("self card")} />
                                                    <span className="text-gray-700">Self Card
                                                        {/* (<CurFt currency={fares && fares?.symbol || "INR"} price={finalAmount - fares.TotalAgentMarkup || fares && fares.GrandTotal - fares.TotalAgentMarkup} />) */}
                                                    </span>
                                                </label>
                                                {showUseWallet &&
                                                    <label className="flex items-center">
                                                        <input type="checkbox" defaultChecked={false} id="accepttnc" value="1" name="payment" className="mr-2" onChange={handleuseWallet} />
                                                        <span className="text-gray-700">Use Wallet (<CurFt currency={fares && fares?.symbol || "INR"} price={WalletBalance && WalletBalance?.balances?.bookable_balance} />) </span>
                                                    </label>
                                                }
                                                <label className="flex items-center">
                                                    <input type="radio" name="payment" className="mr-2" checked={paymentType === "customer card"} onChange={(e) => e.target.checked && setpaymentType("customer card")} />
                                                    <span className="text-gray-700">Customer Card
                                                        {/* (<CurFt currency={fares && fares?.symbol || "INR"} price={finalAmount || fares && fares.GrandTotal + fares.TotalAgentMarkup} />) */}
                                                    </span>
                                                </label>
                                            </div>
                                        </div>


                                        {BookingStatus && BookingStatus == "" &&
                                            <>
                                                <div className="mb-4">
                                                    <p className="text-gray-600 text-xs">
                                                        By proceeding, I agree to Holidayfly's User Agreement, Terms of Service and Cancellation & Property Booking Policies.
                                                    </p>
                                                </div>
                                                <button onClick={() => setOpenConfirm(true)} className="w-full py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors" >
                                                    Proceed To Payment
                                                </button>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="w-96">
                                <div className="sticky top-6 border border-gray-200 rounded-lg p-6">
                                    <h3 className="font-semibold text-gray-800 mb-4">Fare Details</h3>

                                    <div className="space-y-3 mb-4">
                                        <div className="flex justify-between">
                                            <span className="text-gray-600">{fares && fares.roomCoun} Room(s) x {fares && fares.nightCoun} Night(s)</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="text-gray-600">Base Fare</span>
                                            <span className="text-gray-800">{fares && fares.symbol} {fares && fares.BaseFare}</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="text-gray-600">Hotel Taxes</span>
                                            <span className="text-gray-800">{fares && fares.symbol} {fares && fares.TaxesandFee}</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="text-gray-600">Convenience Fee</span>
                                            <span className="text-gray-800">{fares && fares.symbol} {((fares && fares.FixedMarkUp) + (fares && fares.GSTOnMarkUp))}</span>
                                        </div>
                                        {fares.TotalAgentMarkup > 0 && (
                                            <div className="flex justify-between text-sm">
                                                <span className="text-gray-600">Markup</span>
                                                <span className="text-gray-900">{fares && fares.symbol} {(fares && fares.TotalAgentMarkup)}</span>
                                            </div>
                                        )}
                                        {fares.Discount > 0 && (
                                            <div className="flex justify-between text-sm">
                                                <span className="text-gray-600">Discount</span>
                                                <span className="text-gray-900">{fares && fares.symbol} {(fares && fares.Discount)}</span>
                                            </div>
                                        )}
                                        <div className="flex justify-between border-t border-gray-200 pt-3">
                                            <span className="text-gray-600 font-medium">Price after Discount</span>
                                            <span className="text-gray-800 font-medium">{fares && fares.symbol} {fares && fares.GrandTotal + fares.TotalAgentMarkup}</span>
                                        </div>
                                    </div>
                                    <div className="flex justify-between items-center border-t border-gray-300 pt-4">
                                        <span className="text-lg font-semibold text-gray-800">Total Amount</span>
                                        <span className="text-lg font-bold text-gray-800">{fares && fares.symbol} {fares && fares.GrandTotal + fares.TotalAgentMarkup}</span>
                                    </div>
                                </div>
                            </div>

                            {openConfirm && (
                                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                                    <div className="bg-white p-6 rounded-xl shadow-lg w-80 text-center">
                                        <h2 className="text-lg font-semibold mb-4">
                                            Confirm before proceed!
                                        </h2>
                                        <p className="text-sm text-gray-600 mb-6">
                                            Are you sure you want to proceed with this booking?
                                        </p>
                                        <div className="flex justify-center gap-3">
                                            <button
                                                onClick={() => setOpenConfirm(false)}
                                                className="px-4 py-2 rounded-lg border border-gray-300"
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                disabled={isWalletBookingSubmitted}
                                                onClick={handlePayment}
                                                className="px-5 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-medium shadow transition"
                                            >
                                                {isWalletBookingSubmitted ? 'Booking Process wait...' : 'Proceed To Pay'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}


        </>
    );
};

export default PaymentPage;